/* eslint-disable */
import React, { useState } from "react";
import { Form, FormElement } from "@progress/kendo-react-form";
import { EditPageHeader } from "../../components/EditPageHeader";
import * as API from "../../framework/API/api";
import {
  ENTITYNAME, LOGEVENT, MODULE, SALESSTATUS, TOAST_TYPES
} from "../../framework/constant/constant";
import { useEffect } from "react";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import BossDialog from "../../components/BossDialog";
import ToastNotification from "../../components/ToastNotification";

const OttProductEditForm = (props) => {
  const lang = useTranslation();
  const [segments, setSegments] = useState([]);
  const [regions, setRegions] = useState([]);
  const [showPaymentPlan, setShowPaymentPlan] = useState(false);


  const blankDataItem = {
    ...props.item,
    Title: props.item.copy
      ? "Copy of " + props.item.Title
      : props.item.Title ?? "",
    Description: props.item.Description,
    SalesStatus: props.item.SalesStatus ?? SALESSTATUS[0],
    Region: props.item.Region ?? {},
    Segments: props.item.Segments ?? [],
    Archive: props.item.Archive ?? false,
  };

  useEffect(() => {
    loadcombo();
  }, []);

  const [dataItem, setDataItem] = useState(blankDataItem);

  const loadcombo = async () => {
    const segmentsRes = await API.getDataLookup(ENTITYNAME.OttSegment, { query: ["Archive", '=', false], sort: { Description: 1 } });
    setSegments(segmentsRes.data);
    const regionRes = await API.getDataLookup(ENTITYNAME.Region, { query: ["Archive", '=', false], sort: { Description: 1 } });
    setRegions(regionRes.data);
  };

  const onChangeForm = (e) => {
    if (e.target.name == 'Archive') {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }
  };

  const isValid = () => {

    if (dataItem.Title == "" || dataItem.Title == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_name_error_message}` });
      return false;
    }
    if (dataItem.Description == "" || dataItem.Description == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_description_error_message}` });
      return false;
    }
    if (!dataItem.Region || Object.keys(dataItem.Region).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_region_error_message}` });
      return false;
    }
    if (dataItem.Segments.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_segment_error_message}` });
      return false;
    }
    if (Object.keys(dataItem.SalesStatus).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_sales_status_error_message}` });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (isValid()) {
      const saveData = {
        SID: dataItem.SID ?? 0,
        Title: dataItem.Title,
        Description: dataItem.Description,
        SalesStatus: {
          _id: dataItem.SalesStatus._id,
          SID: dataItem.SalesStatus.SID,
          Name: dataItem.SalesStatus.Name,
        },
        Region: dataItem.Region && Object.keys(dataItem?.Region).length > 0 ? {
          _id: dataItem.Region._id,
          Description: dataItem.Region.Description
        } : {},
        Segments: dataItem.Segments.map((x) => {
          return {
            _id: x._id,
            SID: x.SID,
            Description: x.Description
          }
        }),
        Archive: dataItem.Archive ?? false,
        checkDuplicate: true,
        query: [["Title", "=", dataItem.Title]],
      };

      let res = await API.saveData(ENTITYNAME.OttProduct, saveData);

      if (res.success) {
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.OTT_PRODUCT, data: res.data, message: res.message };
        API.SaveLogs(logData);
        props.cancelEdit();
        utility.deleteLocalStorageItem(ENTITYNAME.OttProduct)
        props.refresh();
        return;
      } else {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      }
    }
  };



  // const handlePaymentPlanList = (dataList) => {
  //   //check duplicate
  //   setDataItem({...dataItem,PaymentPlan : [...dataItem.PaymentPlan,...dataList] })
  // }
  // const removePaymentPlan = (item) => {
  //   var newList = dataItem.PaymentPlan.filter((x) => x._id != item._id);
  //   setDataItem({...dataItem,PaymentPlan : newList })
  // }

  // const MyCommandCell = (props)=>(
  //   <div className="mt-1" style={{display:"flex"}}>
  //   <DeleteRoundButton onClick={()=>ConfirmDeleteAlert(()=>removePaymentPlan(props.dataItem),()=>{})}/>
  //   </div>
  // )

  return (
    <>
      <BossDialog
        title={
          props.item.Title ?? `${lang.create_ott_product_type_dialog_header}`
        }
        onClose={props.cancelEdit}
        width={"800px"}
      >
        <EditPageHeader
          title={""}
          onSubmit={handleSubmit}
          onCancel={props.cancelEdit}
          showTitle={false}
        />
        <Form
          initialValues={dataItem}
          render={(formRenderProps) => (
            <FormElement>
              <div className="row">
                <div className="col-12">
                  <div className="row mt-2">
                    <div className="col-6">
                      <label>{lang.name_label} *</label>
                      <input
                        name="Title"
                        type="text"
                        onChange={onChangeForm}
                        value={dataItem.Title}
                        className="form-control form-control-sm"
                      />
                    </div>
                    <div className="col-6">
                      <label>{lang.description_label} *</label>
                      <input
                        name="Description"
                        type="text"
                        onChange={onChangeForm}
                        value={dataItem.Description}
                        className="form-control form-control-sm"
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-6">
                      <label htmlFor="TabView">
                        {lang.sales_status_label} *
                      </label>
                      <DropDownList
                        style={{
                          backgroundColor: "white",
                        }}
                        data={SALESSTATUS}
                        name="SalesStatus"
                        textField="Name"
                        dataItemKey="SID"
                        value={dataItem.SalesStatus}
                        onChange={onChangeForm}
                      />
                    </div>
                    <div className='col-6'>
                      <label>{lang.region_label} *</label>
                      <DropDownList
                        className="form-control form-control-sm"
                        style={{ background: "white" }}
                        data={regions}
                        name="Region"
                        textField='Description'
                        dataItemKey='_id'
                        value={dataItem?.Region}
                        onChange={onChangeForm}
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className='col-6'>
                      <label htmlFor="TabView">{lang.segment_label} *</label>
                      <MultiSelect
                        style={{
                          backgroundColor: "white",
                        }}
                        data={segments}
                        name="Segments"
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.Segments}
                        onChange={onChangeForm}
                      />
                    </div>
                    <div className="col-6" style={{marginTop: "25px"}}>
                      <input type={'checkbox'}
                        name={"Archive"}
                        label={lang.archive}
                        value={dataItem.Archive}
                        checked={dataItem.Archive}
                        onClick={onChangeForm}
                        onChange={() => { }}
                      />
                      <label className='ml-2'>{lang.archive}</label>
                    </div>
                  </div>
                  {/* <div className="row mt-3">
                  
                  <div className="col-8">
                       <AddRoundButton onClick={() => setShowPaymentPlan(true)} title={lang.add_payment_plan_tooltip}/>
                  </div>
                  <div className="col-4">
                       <h5 className="pull-right">{lang.payment_plan_label}</h5>
                  </div>
                  </div>  
                   <div className="row ml-2 mr-2">
                  <Grid data={dataItem.PaymentPlan} style={{height : '180px' ,margin:'5px 0px'}}>
                      <GridColumn cell={MyCommandCell} width={"35px"} locked={true} />
                      <GridColumn field="Description" title={lang.description_label} editable={false}  />
                      <GridColumn field="OttPeriod.Name" title={lang.ott_period_label} editable={false} />
                      <GridColumn field="Currency.Description" title={lang.currency_label} editable={false}/>
                      <GridColumn field="Amount" title={lang.amount_label} editable={false} />          
                  </Grid>
                  </div> {showPaymentPlan && <CollectionSelection entityname={ENTITYNAME.PaymentPlan} title={lang.select_payment_plan_collection} closeForm={() => setShowPaymentPlan(false)} setDataList={handlePaymentPlanList} width={"50vw"} height={"60vh"}/>} */}
                </div>
              </div>
            </FormElement>
          )}
        />
      </BossDialog>
    </>
  );
};

export default OttProductEditForm;